<template>
	<section>
		<!-- 追加费用 -->
		<div class="wrap">
			<span class="title" @click="showTips(1)">追加费用</span>
			<div class="content">
				<div class="add-wrap">
					<div class="add-money">
						追加
						<input type="text" v-model="addMoney" />
						元
					</div>
					<div class="add-list">
						<span v-for="(item, index) in moneyList" :key="index" :class="flag == index ? 'current' : ''" @click="selectAddMoney(item,index)">{{ item }}</span>
					</div>
				</div>

				<ul class="money-use">
					<li v-for="(item, index) in useList" :key="index" :class="useFlag == index ? 'active' : ''" @click="selectUseMoney(item,index)">
						{{ item }}
						<input type="text" v-show="index == 3" v-model="uesContent" />
					</li>
				</ul>

				<div class="btn-wrap">
					<span>您确定要追加费用吗？</span>
					<div class="btn">
						<div class="submit" @click="addOrderMoney">确定</div>
						<div class="cancel" @click="uesContent = ''">取消</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 添加进度 -->
		<div class="add-follow">
			<span class="title"  @click="showTips(2)">添加进度</span>
			<div class="follow-text">
				<textarea placeholder="请描述您的说明，我们将跟进解决。" v-model="content"></textarea>
				<div class="btn-wrap no-border">
					<span>您确定要在进度上添加留言吗？</span>
					<div class="btn">
						<div class="submit" @click="addFollowRecord">确定</div>
						<div class="cancel" @click="content = ''">取消</div>
					</div>
				</div>
			</div>
		</div>

		<common-modal v-if="isShowTips" :is-show-close="isShowClose" @close="isShowTips = false">
			<div class="agree-wrap">
				<div class="agree-text">
					<template v-if='addTips'>
						<p>商家可根据处理进度，在该订单上追加对应费用</p>
						<p>加急费：期望订单加急处理，但能否加急根据订单实际情况</p>
						<p>打赏金：对处理人员付出表示感谢，打赏相应费用</p>
						<p>补偿金：订单处理过程中，与商家协商一致，给顾客额外补偿费费用 </p>
					</template>

					<template v-if='followTips'>
						<p>商家可根据订单处理情况，添加建设性建议。</p>
					</template>
				</div>
			</div>
		</common-modal>

		<!-- 支付成功弹框 -->
		<pay-success-modal v-if="isSuccess" :charge-money="addMoney" :order_uuid="order_uuid" :addContent='addContent' type="add"></pay-success-modal>

		<pay-modal @close="close" @addBack="addBack" v-if="isPayModal" :add_order_uuid="add_order_uuid" :charge-money="addMoney" :isAppend="true"
		 type="add" ref="payModal"></pay-modal>
	</section>
</template>

<script>
	import {
		addFollowRecord,
		getOrderAdd
	} from '@/api/order';
	import payModal from '@/components/payModal';
	import paySuccessModal from '@/components/paySuccessModal';
	import commonModal from '@/components/commonModal.vue';
	export default {
		components: {
			payModal,
			paySuccessModal,
			commonModal
		},
		data() {
			return {
				order_uuid: this.$route.query.order_uuid,
				addMoney: '100',
				flag: 1,
				useFlag: 0,
				moneyList: ['50', '100', '200', '500'],
				useList: ['加急费', '补偿金', '打赏金', '其它'],
				uesContent: '',
				addContent: '加急费',
				content: '',
				isPayModal: false,
				isSuccess: false,
				isShowTips:false,
				isShowClose:true,
				addTips:false,
				followTips:false,
				add_order_uuid: '' // 追加金额支付的订单
			};
		},

		methods: {
			async addFollowRecord() {
				if (!this.content) {
					this.$message('请输入进度说明');
					return;
				}
				const postData = {
					content: this.content,
					is_admin: 1
				};
				const {
					status,
					data
				} = await addFollowRecord(this.order_uuid, postData);
				if (status !== 200) return;
				this.content = '';
				this.$message.success('增加记录成功');
				this.$parent.$refs.follow.getOrderFollow();
			},

			// 生成追加金额订单
			async addOrderMoney() {
				if (this.useFlag == '3') {
					if (!this.uesContent) {
						this.$message('请输入追加费用类型');
						return;
					}
					this.addContent = this.uesContent;
				}

				const obj = {
					order_uuid: this.order_uuid,
					add_price: this.addMoney,
					add_content: this.addContent,
					add_remarks:this.addContent
				};
				const {
					data,
					status
				} = await getOrderAdd(obj);
				if (status !== 200) return; // 成功下单之后，展示支付,并且标记为追加订单支付
				this.add_order_uuid = data.add_order_uuid;
				this.isPayModal = true;
				this.$nextTick(() => {
					this.$refs.payModal.payAddClick(1);
				});
			},

			selectAddMoney(item, index) {
				this.flag = index;
				this.addMoney = item;
			},

			selectUseMoney(item, index) {
				this.useFlag = index;
				if (this.useFlag != '3') {
					this.uesContent = '';
					this.addContent = item;
				}
			},

			// 追加费用成功回调
			addBack() {
				this.$nextTick(() => {
					this.isSuccess = true;
				});
			},

			showTips(index){
				if(index ==1){
					this.followTips = false;
					this.addTips = true
				}
				else{
					this.addTips = false
					this.followTips = true;
				}
				this.isShowTips = true
			},

			close() {
				this.isPayModal = false;
				this.isShowTips = false
				this.followTips = false;
				this.addTips = false;
			}
		}
	};
</script>

<style lang="scss" scoped>
	@include input-nubmer;

	textarea::-webkit-input-placeholder {
		@include textarea-placeholder;
	}

	textarea::-moz-placeholder {
		/* Mozilla Firefox 19+ */
		@include textarea-placeholder;
	}

	textarea:-moz-placeholder {
		/* Mozilla Firefox 4 to 18 */
		@include textarea-placeholder;
	}

	textarea:-ms-input-placeholder {
		/* Internet Explorer 10-11 */
		@include textarea-placeholder;
	}

	.title {
		@include font-style;
		cursor: pointer;
		font-size: 20px;
		color: #000000;
		padding-right: 40px;
		background: url(../../../assets/img/question.png) no-repeat right center;
		background-size: 20px;
	}

	.btn-wrap {
		display: flex;
		align-items: center;
		justify-content: space-between;
		border-top: 1px solid #f0f0f0;
		box-sizing: border-box;
		padding-top: 20px;

		.btn {
			display: flex;
			align-items: center;

			.submit {
				@include cursor-style;
				width: 80px;
				height: 36px;
				line-height: 36px;
				box-sizing: border-box;
				text-align: center;
				background: #ff8e1c;
				box-shadow: 1px 3px 6px 0px rgba(102, 102, 102, 0.16);
				border-radius: 5px;
				font-size: 15px;
				font-family: Microsoft YaHei;
				font-weight: bold;
				color: #ffffff;
			}

			.cancel {
				@include cursor-style;
				@extend .submit;
				box-shadow: none;
				font-weight: 400;
				background: #ffffff;
				border: 1px solid #9a9a9a;
				color: #9a9a9a;
				margin-left: 20px;
			}
		}
	}

	.wrap {
		.content {
			// width: 525px;
			margin-top: 30px;
			padding: 26px;
			box-sizing: border-box;
			background: #ffffff;
			box-shadow: 1px 3px 6px 0px rgba(102, 102, 102, 0.16);

			.add-wrap {
				display: flex;
				align-items: center;
				justify-content: space-between;

				.add-money {
					font-size: 18px;
					@include font-style;
					color: #343434;

					input {
						appearance: none;
						outline: none;
						border: none;
						width: 80px;
						border-bottom: 1px solid #343434;
						text-align: center;
					}
				}

				.add-list {
					display: flex;
					align-items: center;

					span {
						cursor: pointer;
						width: 62px;
						height: 24px;
						box-sizing: border-box;
						margin-right: 8px;
						line-height: 24px;
						text-align: center;
						background: #ffffff;
						border: 1px solid #9a9a9a;
						border-radius: 6px;
						font-size: 16px;
						color: #9a9a9a;
						@include font-style;
					}

					.current {
						border: 1px solid #ff8e1c;
						color: #ff8e1c;
						background: #fff3e6;
					}
				}
			}

			.money-use {
				margin: 30px 0;
				display: flex;
				flex-wrap: wrap;
				align-items: center;

				li {
					cursor: pointer;
					margin-right: 45px;
					margin-bottom: 18px;
					font-size: 16px;
					@include font-style;
					color: #858585;
					padding-left: 24px;
					background: url(../../../assets/img/un-select.png) no-repeat left center;
					background-size: 14px;

					input {
						appearance: none;
						outline: none;
						border: none;
						width: 130px;
						border-bottom: 1px solid #343434;
						text-align: center;
					}
				}

				li:last-child {
					margin-bottom: 0;
				}

				.active {
					background: url(../../../assets/img/select.png) no-repeat left center;
					background-size: 14px;
				}
			}
		}
	}

	.add-follow {
		margin-top: 30px;

		.follow-text {
			// width: 525px;
			box-sizing: border-box;
			padding: 30px 40px;
			margin-top: 30px;
			background: #ffffff;
			box-shadow: 1px 3px 6px 0px rgba(102, 102, 102, 0.16);

			textarea {
				width: 100%;
				box-sizing: border-box;
				resize: none;
				padding: 20px 0 0 20px;
				height: 180px;
				background: #f5f9fc;
			}

			.no-border {
				border: none;
			}
		}
	}

	.agree-wrap{
	    h1{
	        border-bottom: 0.026667rem solid #E9E9E9;
	        padding: 15px;
	        text-align:center;
	        @include font-style;
	        font-size: 20px;
	        color: #000000;
	    }
	    .agree-text{
	        box-sizing: border-box;
	        padding: 40px;
	        background: #FFFFFF;
	        line-height:30px;
	        letter-spacing: 2px;
	        p{
	            margin-bottom: 20px;
	        }
	        p:last-child{
	            margin-bottom: 0;
	        }
	    }
	}
</style>
